// Libs
import React from 'react'

// CSS
import "./styles.scss"

const Form = (props) => {
  return (
    <form className="form" {...props} />
  )
}

export default Form
